import common from './features/common.slice';
import permissions from './features/permissions.slice';
import signalR from './features/signalr.slice';

export const slices = {
    common,
    permissions,
    signalR,
};